import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { SnackbarProvider } from 'notistack';
import { Analytics } from "@vercel/analytics/react";
import Login from "./components/Login";
import Chat from "./components/Chat";
import NewConnection from "./components/NewConnection";
import PrivateRoute from "./components/PrivateRoute";
import GlobalStyles from "./styles/GlobalStyles";
import MaintenancePage from "./components/MaintenancePage";
import Releases from "./components/Releases";

const App: React.FC = () => {
  // 👉 вот тут включаешь/выключаешь
  const MAINTENANCE_MODE: number = 0; // 1 = показывать maintenance, 0 = работать сайт

  if (MAINTENANCE_MODE === 1) {
    return <MaintenancePage />;
  }

  return (
    <SnackbarProvider 
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <GlobalStyles />
      <Analytics />
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/releases"
          element={
            <PrivateRoute>
              <Releases />
            </PrivateRoute>
          }
        />

        <Route
          path="/chat/:chatId"
          element={
            <PrivateRoute>
              <Chat />
            </PrivateRoute>
          }
        />
        <Route
          path="/chat"
          element={
            <PrivateRoute>
              <Chat />
            </PrivateRoute>
          }
        />

        <Route
          path="/new-connection"
          element={
            <PrivateRoute>
              <NewConnection />
            </PrivateRoute>
          }
        />

        {/* Всё остальное → /chat */}
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Routes>
    </SnackbarProvider>
  );
};

export default App;
